// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ArticleItem__container-d47b68 {
  display: flex;
  padding: 12px var(--padding);
  overflow-wrap: anywhere;
}

.ArticleItem__preview-image-d56a20 {
  width: 40px;
  height: 40px;
  background-color: var(--base-17);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}

.ArticleItem__preview-image-d56a20:hover {
  cursor: pointer;
}

.ArticleItem__icon-f02994 {
  fill: var(--brand-primary-40);
}

.ArticleItem__image-dbb01a {
  object-fit: cover;
  width: inherit;
  height: inherit;
  box-sizing: border-box;
}

.ArticleItem__info-ca25f9 {
  margin-inline-start: 16px;
}

.ArticleItem__title-a4634b {
  font: var(--font-body-6);
  letter-spacing: var(--font-spacing-body-6);
  color: var(--base-110);
  text-align: left;
}

.ArticleItem__title-a4634b:hover {
  cursor: pointer;
}

.ArticleItem__description-b362af {
  font: var(--font-body-5);
  letter-spacing: var(--font-spacing-body-5);
  color: var(--base-80);
  margin-top: 2px;
}

.ArticleItem__list-af032e {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.ArticleItem__list-item-c34c41 {
  margin-top: 2px;
}

.ArticleItem__link-bad270 {
  color: var(--brand-primary-40);
  text-decoration: none;
}

.ArticleItem__link-bad270:hover {
  color: var(--brand-primary-40);
  text-decoration: underline;
}

@supports (display: block) {
  .ArticleItem__link-bad270:focus-visible {
    color: var(--brand-primary-40);
    text-decoration: underline;
  }
}
.ArticleItem__link-bad270:active {
  color: var(--brand-primary-50);
  text-decoration: none;
}

.ArticleItem__link-bad270:disabled {
  color: var(--brand-primary-20);
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/main/SharedData/Articles/ArticleItem/ArticleItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,4BAAA;EACA,uBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,gCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,qBAAA;EACA,eAAA;AACF;;AAEA;EACE,qBAAA;EACA,SAAA;EACA,UAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,8BAAA;EACA,qBAAA;AACF;;AAEA;EACE,8BAAA;EACA,0BAAA;AACF;;AAEA;EACE;IACE,8BAAA;IACA,0BAAA;EACF;AACF;AAEA;EACE,8BAAA;EACA,qBAAA;AAAF;;AAGA;EACE,8BAAA;EACA,qBAAA;AAAF","sourcesContent":[".container {\n  display: flex;\n  padding: 12px var(--padding);\n  overflow-wrap: anywhere;\n}\n\n.preview-image {\n  width: 40px;\n  height: 40px;\n  background-color: var(--base-17);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  overflow: hidden;\n}\n\n.preview-image:hover {\n  cursor: pointer;\n}\n\n.icon {\n  fill: var(--brand-primary-40);\n}\n\n.image {\n  object-fit: cover;\n  width: inherit;\n  height: inherit;\n  box-sizing: border-box;\n}\n\n.info {\n  margin-inline-start: 16px;\n}\n\n.title {\n  font: var(--font-body-6);\n  letter-spacing: var(--font-spacing-body-6);\n  color: var(--base-110);\n  text-align: left;\n}\n\n.title:hover {\n  cursor: pointer;\n}\n\n.description {\n  font: var(--font-body-5);\n  letter-spacing: var(--font-spacing-body-5);\n  color: var(--base-80);\n  margin-top: 2px;\n}\n\n.list {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n\n.list-item {\n  margin-top: 2px;\n}\n\n.link {\n  color: var(--brand-primary-40);\n  text-decoration: none;\n}\n\n.link:hover {\n  color: var(--brand-primary-40);\n  text-decoration: underline;\n}\n\n@supports (display: block) {\n  .link:focus-visible {\n    color: var(--brand-primary-40);\n    text-decoration: underline;\n  }\n}\n\n.link:active {\n  color: var(--brand-primary-50);\n  text-decoration: none;\n}\n\n.link:disabled {\n  color: var(--brand-primary-20);\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ArticleItem__container-d47b68`,
	"preview-image": `ArticleItem__preview-image-d56a20`,
	"previewImage": `ArticleItem__preview-image-d56a20`,
	"icon": `ArticleItem__icon-f02994`,
	"image": `ArticleItem__image-dbb01a`,
	"info": `ArticleItem__info-ca25f9`,
	"title": `ArticleItem__title-a4634b`,
	"description": `ArticleItem__description-b362af`,
	"list": `ArticleItem__list-af032e`,
	"list-item": `ArticleItem__list-item-c34c41`,
	"listItem": `ArticleItem__list-item-c34c41`,
	"link": `ArticleItem__link-bad270`
};
module.exports = ___CSS_LOADER_EXPORT___;
